import { useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import { errorMessage } from '@/shared/api/httpClient'
import { useAuth } from '@/shared/auth/useAuth'
import { Blueprint, Corners } from '@/shared/ui/Blueprint'
import { Wordmark } from '@/shared/ui/Wordmark'

export function LoginPage() {
  const { user, login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  if (user) return <Navigate to="/" replace />

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError(null)
    try {
      await login(email, password)
      // Preserva a query string: /oauth/consent?req=… depende dela.
      const from = (location.state as { from?: { pathname: string; search: string } } | null)?.from
      navigate(from ? from.pathname + from.search : '/', { replace: true })
    } catch (err) {
      setError(errorMessage(err, 'Não foi possível entrar.'))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div style={{ flex: 1, display: 'grid', placeItems: 'center', padding: 'clamp(24px,8vw,60px) clamp(16px,5vw,24px)' }}>
      <Blueprint style={{ padding: 'clamp(20px,6vw,34px)', width: '100%', maxWidth: 400 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 26 }}>
          <Wordmark style={{ fontSize: 22 }} />
          <span className="kicker" style={{ letterSpacing: '0.12em' }}>
            console de controle
          </span>
        </div>
        <h3 style={{ margin: '0 0 4px' }}>Entrar</h3>
        <p className="text-muted" style={{ fontSize: 13, margin: '0 0 20px' }}>
          Sua casa e suas chaves de agente ficam nesta conta.
        </p>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="field">
            <label htmlFor="login-email">E-mail</label>
            <input
              id="login-email"
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div className="field">
            <label htmlFor="login-password">Senha</label>
            <input
              id="login-password"
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          {error && <p className="form-error">{error}</p>}
          <button
            type="submit"
            className="btn btn-primary btn-block blueprint"
            disabled={submitting || !email.trim() || !password.trim()}
            style={{ padding: 12, minHeight: 46 }}
          >
            <Corners />
            {submitting ? 'Entrando…' : 'Entrar'}
          </button>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <button type="button" className="btn btn-ghost" disabled>
              Esqueci a senha
            </button>
            <button type="button" className="btn btn-ghost" disabled>
              Criar conta
            </button>
          </div>
        </form>
      </Blueprint>
    </div>
  )
}
